import styled from 'styled-components'

export const Title = styled.h3`
	font-size: ${({ theme }) => theme.font.size.base};
	font-weight: 700;
	line-height: 24px;
	margin: 4px 0 4px;
`
